// extracted by mini-css-extract-plugin
export var centeredContent = "p_6";
export var heroWithTitle = "p_3";
export var pageContent = "p_t";
export var starIcon = "p_5";
export var subtitleContainer = "p_4";
export var titleContainer = "p_T";